const ADMIN_EMAILS = [
  "taylormoyle93@gmail.com",
  "moylekimberly@yahoo.com",
  "mmoyle70@gmail.com",
];

const ADMIN_DOMAINS = ["moylemanor.com"];

export const isAdminEmail = (email: string | null | undefined): boolean => {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  if (ADMIN_EMAILS.includes(normalized)) return true;
  const at = normalized.lastIndexOf("@");
  if (at === -1) return false;
  const domain = normalized.slice(at + 1);
  return ADMIN_DOMAINS.includes(domain);
};
